import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"moon-rising"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3.49903 15C3.49903 15 3.20173 14.2715 3.13507 14.0227C1.8486 9.22151 4.69784 4.28648 9.49903 3C9.14617 4.31269 9.19128 5.71513 9.56838 7.12252C10.7119 11.3903 15.0986 13.9229 19.3663 12.7794C19.8747 12.6432 20.3585 12.4609 20.8143 12.2383C20.7618 13.1057 20.499 14 19.999 15","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M2 19H9L12 17L15 19H22","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MoonRising = Vue.extend<IconProps>({
  name: 'MoonRisingIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'moon-rising',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default MoonRising;
